import {NgModule} from '@angular/core';
import {GnModalButtonDirective} from './modal-button.directive';
import {GnMessageServiceModule} from '../message-service/message-service.module';
import {NzModalModule} from 'ng-zorro-antd/modal';


@NgModule({
  declarations: [GnModalButtonDirective],
  exports: [
    GnModalButtonDirective
  ],
  imports: [
    NzModalModule,
    GnMessageServiceModule
  ]
})
export class GnModalButtonModule {
}
